import React, { useState } from 'react'
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";

const testimonials = [
   {
      id: 1,
      title: "Great Work",
      content: "“I think Educrat is the best theme I ever seen this year. Amazing design, easy to customize and a design quality superlative account on its cloud platform for the optimized performance”",
      avatar: "/testimonials/1.png",
      name: "Courtney Henry",
      role: "Web Designer"
   },
   {
      id: 2,
      title: "Excellent Quality",
      content: "“The course content is incredibly comprehensive and well-structured. The instructors are knowledgeable and provide practical insights that are immediately applicable in real-world scenarios.”",
      avatar: "/testimonials/2.png",
      name: "Ronald Richards",
      role: "President of Sales"
   },
   {
      id: 3,
      title: "Outstanding Support",
      content: "“The support team is always responsive and helpful. The community aspect makes learning engaging and the platform is intuitive to use with excellent resources.”",
      avatar: "/testimonials/3.png",
      name: "Annette Black",
      role: "Nursing Assistant"
   }
];

function ContentSection() {
   const [currentTestimonial, setCurrentTestimonial] = useState(0);
   const [transitionDirection, setTransitionDirection] = useState('next');

   const nextTestimonial = () => {
      setTransitionDirection('next');
      setCurrentTestimonial((prev) =>
         prev === testimonials.length - 1 ? 0 : prev + 1
      );
   };

   const prevTestimonial = () => {
      setTransitionDirection('prev');
      setCurrentTestimonial((prev) =>
         prev === 0 ? testimonials.length - 1 : prev - 1
      );
   };

   const goToTestimonial = (index) => {
      setTransitionDirection(index > currentTestimonial ? 'next' : 'prev');
      setCurrentTestimonial(index);
   };

   return (
      <div className="w-full p-4">
         <h2 className="text-3xl md:text-4xl font-bold text-dark-1 dark:text-white mb-4">
            Nos Makers <span className="text-red-4"> témoignent</span>
         </h2>
         <p className="text-gray-600 dark:text-gray-300 mb-8">
            Témoignages de jeunes makers et parent.
         </p>

         {/* Testimonial Slider */}
         <div className="relative mt-8 lg:mt-8">
            {/* Conteneur du carrousel */}
            <div className="relative h-96 sm:h-80 md:h-72 lg:h-80 xl:h-96 overflow-hidden">
               {testimonials.map((testimonial, index) => (
                  <div
                     key={testimonial.id}
                     className={`absolute top-0 left-0 w-full h-full transition-transform duration-500 ease-in-out
                        ${index === currentTestimonial
                           ? 'translate-x-0 opacity-100 z-10'
                           : transitionDirection === 'next'
                              ? index === (currentTestimonial === 0 ? testimonials.length - 1 : currentTestimonial - 1)
                                 ? '-translate-x-full opacity-0 z-0'
                                 : 'translate-x-full opacity-0 z-0'
                              : index === (currentTestimonial === testimonials.length - 1 ? 0 : currentTestimonial + 1)
                                 ? 'translate-x-full opacity-0 z-0'
                                 : '-translate-x-full opacity-0 z-0'
                        }`}
                  >
                     <div className="bg-white dark:bg-gray-800 rounded-xl p-6 sm:p-8 md:p-10 border border-gray-200 dark:border-gray-700 shadow-lg h-full flex flex-col justify-between">
                        <h4 className="text-lg sm:text-xl font-medium text-red-4 mb-4">
                           {testimonial.title}
                        </h4>
                        <p className="text-gray-700 dark:text-gray-300 text-base sm:text-lg leading-relaxed mb-6 flex-1">
                           {testimonial.content}
                        </p>
                        <div className="flex items-center pt-4 border-t border-gray-200 dark:border-gray-700">
                           <img
                              src={testimonial.avatar}
                              alt={testimonial.name}
                              className="w-12 h-12 sm:w-14 sm:h-14 rounded-full mr-4"
                           />
                           <div>
                              <div className="font-medium text-gray-900 dark:text-white text-base sm:text-lg">
                                 {testimonial.name}
                              </div>
                              <div className="text-sm sm:text-base text-gray-500 dark:text-gray-400">
                                 {testimonial.role}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               ))}
            </div>
            <div className="flex items-center justify-start mt-8 space-x-4">
               <button
                  onClick={prevTestimonial}
                  className="p-3 rounded-full text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                  aria-label="Previous testimonial"
               >
                  <FaArrowLeftLong className="w-6 h-6" />
               </button>

               <div className="flex space-x-3">
                  {testimonials.map((_, index) => (
                     <button
                        key={index}
                        onClick={() => goToTestimonial(index)}
                        className={`w-3 h-3 rounded-full ${index === currentTestimonial
                           ? 'bg-red-4'
                           : 'bg-gray-300 dark:bg-gray-600'
                           }`}
                        aria-label={`Go to testimonial ${index + 1}`}
                     />
                  ))}
               </div>

               <button
                  onClick={nextTestimonial}
                  className="p-3 rounded-full text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                  aria-label="Next testimonial"
               >
                  <FaArrowRightLong className="w-6 h-6" />
               </button>
            </div>
         </div>
      </div>
   )
}

export default ContentSection